import * as F from "fp-ts/function"
import * as N from "fp-ts/number"
import * as A from "fp-ts/Array"
import * as O from "fp-ts/Option"
import { contramap } from "fp-ts/Ord"

const byDeckNumber = F.pipe(
    N.Ord,
    contramap((deck: { deckNumber: number }) => deck.deckNumber),
)
export const totalDecks = (
    decks:
        | {
              deckNumber: number
          }[]
        | undefined,
): number | undefined => {
    if (!decks) return undefined

    return F.pipe(
        decks,
        A.sortBy([byDeckNumber]),
        A.last,
        O.fold(F.constUndefined, (deck) => deck.deckNumber),
    )
}
